//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { DaySelectionDisplayItem } from './DaySelectionDisplayItem';
import { AvailabilityLocationItem } from './AvailabilityLocationItem';

export class TeacherAvailabilityUpdateItem extends ItemBase {
    DaySelection?: DaySelectionDisplayItem | null;
    EndDate?: string | null;
    EndTimeInMinutes?: number;
    Notes?: string | null;
    StartDate?: string | null;
    StartTimeInMinutes?: number;
    Locations?: AvailabilityLocationItem[];
    AllowOnlineBooking?: boolean;

    constructor(initializer?: Partial<TeacherAvailabilityUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherAvailabilityUpdateItem";
}
